<div class="modal-wrapper">
  <img
    *ngIf="modalType === 'PAYMENT'"
    [src]="
      soldError
        ? '../../../assets/img/solde_insuffisant.png'
        : '../../../assets/img/provider_2.png'
    "
    alt="provider icon"
  />
  <p *ngIf="modalType === 'PAYMENT'">
    {{
      soldError
        ? ("SELECT_PAYMENT_MODAL.BALANCE_ERROR_MODAL.P_1" | translate)
        : ("SELECT_PAYMENT_MODAL.P_1" | translate)
    }}
  </p>
  @if (defaultCard) {
    <h2>
      {{ "SELECT_PAYMENT_MODAL.SELECT_TITLE" | translate }}
    </h2>
    <div class="modal-wrapper__select-card-container">
      <app-select-card-button
        [defaultCard]="
          defaultCard.name
            ? defaultCard.name
            : defaultCard.brand
              ? defaultCard.brand
              : ''
        "
      ></app-select-card-button>
    </div>
  }
  <!-- <p
    class="link"
    [ngClass]="defaultCard ? '' : 'red-link'"
    role="button"
    (click)="navigateToPaymentMethods()"
  >
    {{ "SELECT_PAYMENT_MODAL.ADD_CARD" | translate }}
  </p> -->

  @if (!soldError) {
    <div class="modal-wrapper__buttons">
      <app-button
        [loading]="loading"
        [disabled]="loading"
        (onClick)="submit()"
        [innerText]="defaultCard ? 'D’accord' : 'Ajouter un moyen de paiement'"
      ></app-button>
      <app-button
        (onClick)="closeModal()"
        innerText="Annuler"
        [styles]="{ backgroundColor: '#88a8c7' }"
      ></app-button>
    </div>
  } @else {
    <div class="modal-wrapper__buttons">
      <app-button
        [loading]="loading"
        [disabled]="loading"
        (onClick)="submit()"
        innerText="Continuer"
      ></app-button>
    </div>
  }
</div>
